export default "__VITE_ASSET__WLjMKkrt__"